import React, { useEffect, useState } from "react";
import Styles from "./Navbar.module.css";
import logo from "../assets/Logo/IraqWonders.svg";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Navbar links
const Sections = [
	{ path: "/", name: "Home" },
	{ path: "/BookYourGuide", name: "Book your Guide" },
	{ path: "/ExploreIraq", name: "Explore Iraq" },
	{ path: "/AboutUs", name: "About Us" },
	{ path: "/ContactUs", name: "Contact Us" },
];

function Navbar() {
	// to show and hide links list
	const [showNavbar, setShowNavbar] = useState(false);
	const [showMenuIcon, setShowMenuIcon] = useState(true);
	let [language, setLanguage] = useState("");

	useEffect(() => {
		setShowNavbar(false);
		console.log(language, "language");
	}, [language]);

	// for localization
	const { t, i18n } = useTranslation();

	// to check the language
	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	// to change the language depending on the select
	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		setLanguage(lng);
		setShowMenuIcon(true);
	};

	// handle MenuClick
	const handleClick = () => {
		setShowMenuIcon(!showMenuIcon);
		setShowNavbar(!showNavbar);
	};

	return (
		// Parent div
		<nav
			className={Styles.navbar}
			dir={isRtl ? "rtl" : "ltr"}
		>
			{/* logo  */}
			<NavLink
				className={Styles.logo}
				to='/'
			>
				<img
					src={logo}
					alt='IraqWonders'
				/>
			</NavLink>
			{/* navbar links Desktop */}
			<ul className={Styles.navbarLinks}>
				{/* map Sections */}
				{Sections.map((section) => (
					<li key={section.name}>
						<NavLink
							to={section.path}
							className={(navData) =>
								navData.isActive
									? Styles.activeLink
									: Styles.link
							}
						>
							{t(`Navbar.${section.name}`)}
						</NavLink>
					</li>
				))}

				{/* links for login, signup, and launguage */}
				<div className={Styles.rightSection}>
					<li>
						<NavLink
							to='/login'
							className={
								isRtl ? Styles.loginRtl : Styles.login
							}
						>
							{t("Navbar.Login")}
						</NavLink>
					</li>

					<li>
						<NavLink
							to='/Singup'
							className={
								isRtl ? Styles.signupRtl : Styles.signup
							}
						>
							{t("Navbar.Singup")}
						</NavLink>
					</li>

					{/* select Language */}
					<li>
						<select
							className={Styles.selectLanguage}
							onChange={(e) =>
								changeLanguage(e.target.value)
							}
							value={i18n.language}
						>
							<option value='en'>English</option>
							<option value='ar'>عربي</option>
							<option value='ku'>کوردی</option>
						</select>
					</li>
				</div>
			</ul>

			{/* navbar links  Mobile */}
			{showNavbar ? (
				<ul className={Styles.navbarLinksMobile}>
					{/* map Sections */}
					{Sections.map((section) => (
						<li
							key={section.name}
							onClick={() => {
								setShowNavbar(false);
								setShowMenuIcon(true);
							}}
						>
							<NavLink
								to={section.path}
								className={(navData) =>
									navData.isActive
										? Styles.activeLink
										: Styles.link
								}
							>
								{t(`Navbar.${section.name}`)}
							</NavLink>
						</li>
					))}

					{/* links for login, signup, and launguage */}
					<div className={Styles.rightSection}>
						<li
							onClick={() => {
								setShowNavbar(false);
								setShowMenuIcon(true);
							}}
						>
							<NavLink
								to='/login'
								className={
									isRtl ? Styles.loginRtl : Styles.login
								}
							>
								{t("Navbar.Login")}
							</NavLink>
						</li>

						<li
							onClick={() => {
								setShowNavbar(false);
								setShowMenuIcon(true);
							}}
						>
							<NavLink
								to='/Singup'
								className={
									isRtl ? Styles.signupRtl : Styles.signup
								}
							>
								{t("Navbar.Singup")}
							</NavLink>
						</li>

						{/* select Language */}
						<li>
							<select
								className={Styles.selectLanguage}
								onChange={(e) =>
									changeLanguage(e.target.value)
								}
								value={i18n.language}
							>
								<option
									onClick={() => (e) =>
										setLanguage(e.target.value)}
									value='en'
								>
									English
								</option>
								<option
									onClick={() => (e) =>
										setLanguage(e.target.value)}
									value='ar'
								>
									عربي
								</option>
								<option
									onClick={() => (e) =>
										setLanguage(e.target.value)}
									value='ku'
								>
									کوردی
								</option>
							</select>
						</li>
					</div>
				</ul>
			) : null}

			{showMenuIcon ? (
				<div className={Styles.showIcon}>
					<MenuIcon onClick={handleClick} />
				</div>
			) : (
				<div className={Styles.showIcon}>
					<CloseIcon onClick={handleClick} />
				</div>
			)}
		</nav>
	);
}

export default Navbar;
